/**
 * Created by Анжелика on 25.08.2017.
 */
import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

const Account = ({userName, onClick}) => {
    return (
        <div className="account">
            <div className="wrapper">
                <Link to={'/user'} onClick={onClick}><img src="" alt="" /></Link>
                <div className="account-details">
                    <Link to={'/user'} onClick={onClick}><div className="username">{userName}</div></Link>
                    <div className="status">Online</div>
                </div>
            </div>
        </div>
    );
};

Account.propTypes = {
    userName: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};

export default Account;


// WEBPACK FOOTER //
// ./src/components/Account.js